(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/parsers/nodes-date-picker.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/parsers/nodes-date-picker.js');

'use strict';

function nodesFunc(isOpen) {
  var DAYS_IN_WEEK = 7,
    WEEKS_IN_CALENDAR = 6,
    _ = Picker._,
    calendar = this,
    settings = calendar.settings,
    calendarItem = calendar.item,
    nowObject = calendarItem.now,
    selectedObject = calendarItem.select,
    highlightedObject = calendarItem.highlight,
    viewsetObject = calendarItem.view,
    disabledCollection = calendarItem.disable,
    minLimitObject = calendarItem.min,
    maxLimitObject = calendarItem.max,
    tableHead = function (collection, fullCollection) {
      if (settings.firstDay) {
        collection.push(collection.shift());
        fullCollection.push(fullCollection.shift());
      }

      return _.node('thead', _.node('tr', _.group({
        min: 0,
        max: DAYS_IN_WEEK - 1,
        i: 1,
        node: 'th',
        item: function (counter) {
          return [collection[counter], settings.klass.weekdays, 'scope=col title="' + fullCollection[counter] + '"'];
        }
      }))); 
    }((settings.showWeekdaysFull ? settings.weekdaysFull : settings.weekdaysShort).slice(0), settings.weekdaysFull.slice(0)),

    createMonthNav = function (next) {
      return _.node('div', ' ', settings.klass['nav' + (next ? 'Next' : 'Prev')] + (
      next && viewsetObject.year >= maxLimitObject.year && viewsetObject.month >= maxLimitObject.month || !next && viewsetObject.year <= minLimitObject.year && viewsetObject.month <= minLimitObject.month ? ' ' + settings.klass.navDisabled : ''), 'data-nav=' + (next || -1) + ' ' + _.ariaAttr({
        role: 'button',
        controls: calendar.$node[0].id + '_table'
      }) + ' ' + 'title="' + (next ? settings.labelMonthNext : settings.labelMonthPrev) + '"'); 
    },

    createMonthLabel = function () {
      var monthsCollection = settings.showMonthsShort ? settings.monthsShort : settings.monthsFull;

      if (settings.selectMonths) {
        return _.node('select', _.group({
          min: 0,
          max: 11,
          i: 1,
          node: 'option',
          item: function (loopedMonth) {
            return [
            monthsCollection[loopedMonth], 0,
            'value=' + loopedMonth + (viewsetObject.month == loopedMonth ? ' selected' : '') + (viewsetObject.year == minLimitObject.year && loopedMonth < minLimitObject.month || viewsetObject.year == maxLimitObject.year && loopedMonth > maxLimitObject.month ? ' disabled' : '')];
          }
        }), settings.klass.selectMonth, (isOpen ? '' : 'disabled') + ' ' + _.ariaAttr({
          controls: calendar.$node[0].id + '_table'
        }) + ' ' + 'title="' + settings.labelMonthSelect + '"');
      }

      return _.node('div', monthsCollection[viewsetObject.month], settings.klass.month);
    },

    createYearLabel = function () {
      var focusedYear = viewsetObject.year,
        numberYears = settings.selectYears === true ? 5 : ~~(settings.selectYears / 2);

      if (numberYears) {
        var minYear = minLimitObject.year,
          maxYear = maxLimitObject.year,
          lowestYear = focusedYear - numberYears,
          highestYear = focusedYear + numberYears;

        if (minYear > lowestYear) {
          highestYear += minYear - lowestYear;
          lowestYear = minYear;
        }

        if (maxYear < highestYear) {
          var availableYears = lowestYear - minYear,
            neededYears = highestYear - maxYear;
          lowestYear -= availableYears > neededYears ? neededYears : availableYears;
          highestYear = maxYear;
        }
        return _.node('select', _.group({
          min: lowestYear,
          max: highestYear,
          i: 1,
          node: 'option',
          item: function (loopedYear) {
            return [
            loopedYear, 0,
            'value=' + loopedYear + (focusedYear == loopedYear ? ' selected' : '')];
          }
        }), settings.klass.selectYear, (isOpen ? '' : 'disabled') + ' ' + _.ariaAttr({
          controls: calendar.$node[0].id + '_table'
        }) + ' ' + 'title="' + settings.labelYearSelect + '"');
      }

      return _.node('div', focusedYear, settings.klass.year);
    }; 

  return _.node('div', (settings.selectYears ? createYearLabel() + createMonthLabel() : createMonthLabel() + createYearLabel()) + createMonthNav() + createMonthNav(1), settings.klass.header) + _.node('table', tableHead + _.node('tbody', _.group({
    min: 0,
    max: WEEKS_IN_CALENDAR - 1,
    i: 1,
    node: 'tr',
    item: function (rowCounter) {
      var shiftDateBy = settings.firstDay && calendar.create([viewsetObject.year, viewsetObject.month, 1]).day === 0 ? -7 : 0;
      return [_.group({
        min: DAYS_IN_WEEK * rowCounter - viewsetObject.day + shiftDateBy + 1,
        max: function () {
          return this.min + DAYS_IN_WEEK - 1;
        },
        i: 1,
        node: 'td',
        item: function (targetDate) {
          targetDate = calendar.create([viewsetObject.year, viewsetObject.month, targetDate + (settings.firstDay ? 1 : 0)]);
          var isSelected = selectedObject && selectedObject.pick == targetDate.pick,
            isHighlighted = highlightedObject && highlightedObject.pick == targetDate.pick,
            isDisabled = disabledCollection && calendar.disabled(targetDate) || targetDate.pick < minLimitObject.pick || targetDate.pick > maxLimitObject.pick,
            formattedDate = _.trigger(calendar.formats.toString, calendar, [settings.format, targetDate]);
          const hasLinkWrapper = settings.dateLinkIndexUrl && !isDisabled;
          const wrapper = hasLinkWrapper ? 'a' : 'div';
          const hrefLink = hasLinkWrapper ? "href='".concat(settings.dateLinkIndexUrl + formattedDate, "' onclick=event.preventDefault();") : '';
          return [_.node(wrapper, targetDate.date, function (klasses) {
            klasses.push(viewsetObject.month == targetDate.month ? settings.klass.infocus : settings.klass.outfocus);

            if (nowObject.pick == targetDate.pick) {
              klasses.push(settings.klass.now);
            }

            if (isSelected) {
              klasses.push(settings.klass.selected);
            }


            if (isDisabled) {
              klasses.push(settings.klass.disabled);
            }
            return klasses.join(' ');
          }([settings.klass.day]), 'data-pick=' + targetDate.pick + ' ' + _.ariaAttr({
            role: 'gridcell',
            label: formattedDate,
            selected: isSelected && calendar.$node.val() === formattedDate ? true : null,
            activedescendant: isHighlighted ? true : null,
            disabled: isDisabled ? true : null
          }) + ' ' + hrefLink), '', _.ariaAttr({
            role: 'presentation'
          })]; 
        }
      })]; 
    }
  })), settings.klass.table, 'id="' + calendar.$node[0].id + '_table' + '" ' + _.ariaAttr({
    role: 'grid',
    controls: calendar.$node[0].id,
    readonly: true
  })) +
  _.node('div', _.node('button', settings.today, settings.klass.buttonToday, 'type=button data-pick=' + nowObject.pick + (isOpen && !calendar.disabled(nowObject) ? '' : ' disabled') + ' ' + _.ariaAttr({
    controls: calendar.$node[0].id
  })) + _.node('button', settings.clear, settings.klass.buttonClear, 'type=button data-clear=1' + (isOpen ? '' : ' disabled') + ' ' + _.ariaAttr({
    controls: calendar.$node[0].id
  })) + _.node('button', settings.close, settings.klass.buttonClose, 'type=button data-close=true ' + (isOpen ? '' : ' disabled') + ' ' + _.ariaAttr({
    controls: calendar.$node[0].id
  })), settings.klass.footer); 
} 

svs.numbergames.results.parsers.datePicker.nodesFunc = nodesFunc;

 })(window);